"use strict";
exports.__esModule = true;
exports.PlatformMerchantOrderBuilder = exports.PlatformMerchantOrderState = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var MerchantCustomerOrder_1 = require("./MerchantCustomerOrder");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PricingCatalog_1 = require("../base/PricingCatalog");
var ShopifyOrder_1 = require("./ShopifyOrder");
var PlatformMerchantOrderState;
(function (PlatformMerchantOrderState) {
    PlatformMerchantOrderState["NEW"] = "NEW";
    PlatformMerchantOrderState["IN_PRODUCTION"] = "IN_PRODUCTION";
    PlatformMerchantOrderState["SHIPPED"] = "SHIPPED";
    PlatformMerchantOrderState["CANCELED"] = "CANCELED";
    PlatformMerchantOrderState["REJECTED"] = "REJECTED";
    PlatformMerchantOrderState["COMPLETED"] = "COMPLETED";
})(PlatformMerchantOrderState = exports.PlatformMerchantOrderState || (exports.PlatformMerchantOrderState = {}));
var PlatformMerchantOrderBuilder = /** @class */ (function () {
    function PlatformMerchantOrderBuilder(platformMerchantOrder) {
        this.platformMerchantOrder = platformMerchantOrder;
    }
    PlatformMerchantOrderBuilder.initialiseWithPlatformMerchantOrder = function (platformMerchantOrder) {
        return new PlatformMerchantOrderBuilder(platformMerchantOrder);
    };
    PlatformMerchantOrderBuilder.initialiseWithMerchantCustomerOrder = function (platformSaleCatalog, merchantChannelCatalog, merchantDelivery, merchantCustomerOrder) {
        if (merchantCustomerOrder.type !== MerchantCustomerOrder_1.MerchantCustomerOrderType.SHOPIFY)
            throw new core_common_domain_1.Exception("Cannot initiate platform merchant order from an merchant customer order with type !== SHOPIY");
        if (merchantChannelCatalog.availableCollections.length === 0)
            throw new core_common_domain_1.Exception("Cannot initialise platform merchant order from an empty merchant channel catalog with id " + merchantChannelCatalog.id);
        var currency = merchantChannelCatalog.availableCollections[0].retailPrices.currency;
        var platformSellingPricingCatalog = platformSaleCatalog.platformSellingPricingCatalogs.find(function (catalog) { return catalog.currency === currency; });
        if (platformSellingPricingCatalog === undefined)
            throw new core_common_domain_1.Exception("Platform sale catalog " + platformSaleCatalog.id + " does not contain a selling price catalog for currency " + currency);
        var now = core_common_logic_1.CommonLogic.nowToDateTime();
        /* Build the merchant order items only from the items that contain a customised attribute.
         * As such it is possible to have items that appear in the customer order but will not be copied in the merchant order (as they get fulfilled directly by the merchant)
         */
        var filteredLineItems = merchantCustomerOrder.shopOrder.shopify.lineItems.filter(function (lineItem) {
            return ShopifyOrder_1.ShopifyOrderLineItem.containsItemCustomisation(lineItem);
        });
        if (filteredLineItems.length === 0)
            throw new core_common_domain_1.Exception("The merchant customer order " + JSON.stringify(merchantCustomerOrder) + " has no customised line items. Aborting the merchant platform order creation.");
        var items = filteredLineItems.map(function (lineItem) {
            var itemCustomisation = ShopifyOrder_1.ShopifyOrderLineItem.retrieveItemCustomisation(lineItem);
            var merchantChannelProductCollection = merchantChannelCatalog.availableCollections.find(function (ac) { return ac.id === itemCustomisation.designerCatalogReference.productCollectionId; });
            var merchantChannelProduct = merchantChannelProductCollection.products.find(function (p) { return p.id === itemCustomisation.designerCatalogReference.productId; });
            var merchantChannelPieceVariant = merchantChannelProduct.pieceVariants.find(function (pv) { return pv.id === itemCustomisation.designerCatalogReference.pieceVariantId; });
            var merchantChannelAccessoryVariant = merchantChannelProduct.accessoryVariants.find(function (av) { return av.id === itemCustomisation.designerCatalogReference.accessoryVariantId; });
            var piecePlatformPrice = PricingCatalog_1.PricePiece.findPricePiece(platformSellingPricingCatalog.pieces, merchantChannelPieceVariant.pieceReference);
            if (piecePlatformPrice === undefined)
                throw new core_common_domain_1.Exception("Platform sale catalog " + platformSaleCatalog.id + " does not contain a piece price for piece reference " + JSON.stringify(merchantChannelPieceVariant.pieceReference) + " and currency " + currency);
            var accessoryPlatformPrice = PricingCatalog_1.PriceAccessory.findPriceAccessory(platformSellingPricingCatalog.accessories, merchantChannelAccessoryVariant.accessoryReference);
            if (accessoryPlatformPrice === undefined)
                throw new core_common_domain_1.Exception("Platform sale catalog " + platformSaleCatalog.id + " does not contain a accessory price for accessory reference " + JSON.stringify(merchantChannelAccessoryVariant.accessoryReference) + " and currency " + currency);
            var platformMerchantPieceOrderItem = {
                quantity: lineItem.quantity,
                engravings: itemCustomisation.engravings,
                pieceReference: merchantChannelPieceVariant.pieceReference,
                platformPrice: piecePlatformPrice.price,
                merchantRetailPrice: merchantChannelPieceVariant.retailPrice
            };
            var platformMerchantAccessoryOrderItem = {
                quantity: lineItem.quantity,
                accessoryReference: merchantChannelAccessoryVariant.accessoryReference,
                platformPrice: accessoryPlatformPrice.price,
                merchantRetailPrice: merchantChannelAccessoryVariant.retailPrice
            };
            var result = {
                id: lineItem.id,
                accessoryOrderItem: platformMerchantAccessoryOrderItem,
                pieceOrderItem: platformMerchantPieceOrderItem,
                merchantCustomerOrderItemId: lineItem.id
            };
            return result;
        });
        return new PlatformMerchantOrderBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            state: PlatformMerchantOrderState.NEW,
            platformSaleCatalogId: platformSaleCatalog.id,
            merchantPartyId: merchantCustomerOrder.merchantPartyId,
            merchantChannelId: merchantCustomerOrder.merchantChannelId,
            merchantChannelCatalogId: merchantChannelCatalog.id,
            merchantCustomerOrderId: merchantCustomerOrder.id,
            merchantDelivery: merchantDelivery,
            items: items,
            history: [
                {
                    createdAt: now,
                    note: '',
                    state: PlatformMerchantOrderState.NEW
                }
            ],
            createdAt: now,
            updatedAt: now
        });
    };
    PlatformMerchantOrderBuilder.prototype.getId = function () {
        return this.platformMerchantOrder.id;
    };
    PlatformMerchantOrderBuilder.prototype.withId = function (id) {
        this.platformMerchantOrder.id = id;
        return this;
    };
    PlatformMerchantOrderBuilder.prototype.getState = function () {
        return this.platformMerchantOrder.state;
    };
    PlatformMerchantOrderBuilder.prototype.withState = function (state, note) {
        if (note === void 0) { note = ''; }
        this.platformMerchantOrder.state = state;
        this.platformMerchantOrder.history.push({
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            note: note,
            state: state
        });
        return this;
    };
    PlatformMerchantOrderBuilder.prototype.withMerchantDelivery = function (merchantDelivery) {
        this.platformMerchantOrder.merchantDelivery = merchantDelivery;
        return this;
    };
    PlatformMerchantOrderBuilder.prototype.build = function () {
        return this.platformMerchantOrder;
    };
    PlatformMerchantOrderBuilder.prototype.buildUpdate = function () {
        return {
            state: this.platformMerchantOrder.state,
            platformSaleCatalogId: this.platformMerchantOrder.platformSaleCatalogId,
            merchantPartyId: this.platformMerchantOrder.merchantPartyId,
            merchantChannelId: this.platformMerchantOrder.merchantChannelId,
            merchantChannelCatalogId: this.platformMerchantOrder.merchantChannelCatalogId,
            merchantCustomerOrderId: this.platformMerchantOrder.merchantCustomerOrderId,
            merchantDelivery: this.platformMerchantOrder.merchantDelivery,
            items: this.platformMerchantOrder.items,
            history: this.platformMerchantOrder.history
        };
    };
    return PlatformMerchantOrderBuilder;
}());
exports.PlatformMerchantOrderBuilder = PlatformMerchantOrderBuilder;
